import { render, staticRenderFns } from "./sso-saml.vue?vue&type=template&id=52aa2c54&scoped=true&"
import script from "./sso-saml.ts?vue&type=script&lang=ts&"
export * from "./sso-saml.ts?vue&type=script&lang=ts&"
import style0 from "./sso-saml.scss?vue&type=style&index=0&id=52aa2c54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa2c54",
  null
  
)

export default component.exports